import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseInputComponent } from '../base-input/base-input.component';
import { formatCharacterCount } from '../input.helpers';
import { TextareaInputConfig } from '../input.type';

/**
 * Textarea input component.
 * @param maxLength - The maximum length of the text.
 * @param rows - The number of rows.
 */
@Component({
    selector: 'app-textarea-input',
    templateUrl: './textarea-input.component.html',
    providers: [{ provide: BaseInputComponent, useExisting: TextareaInputComponent }]
})
export class TextareaInputComponent extends BaseInputComponent<string> implements OnInit, OnChanges {
    @Input() maxLength: TextareaInputConfig['maxLength'] = 255;
    @Input() rows: TextareaInputConfig['rows'] = 3;
    characterCount: string;

    ngOnInit(): void {
        this.clearValue(this.value());
        this.characterCount = formatCharacterCount(this.maxLength, this.value());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) this.clearValue(changes.value.currentValue);
    }

    override onValueChange(value: string): void {
        super.onValueChange(value);
        this.characterCount = formatCharacterCount(this.maxLength, value);
    }

    // This is to avoid displaying 'undefined' when the value passed in is undefined eg.: model.username, where username is undefined.
    clearValue(value: string) {
        if (!value) this.value.set(null);
    }
}
